define(['text!./templates/mfp-promotion-data.html',
], (templateStr) => {


    return ['MFPPromotionService', (MFPPromotionService) => {
        return {
            restrict: 'E',
            scope: {
                promotion: '=',
            },
            template: templateStr,
            controller: ['$scope', ($scope) => {
                $scope.showPromotionOnGUI = MFPPromotionService.showPromotionOnGUI($scope.promotion);
                $scope.items = MFPPromotionService.getItems($scope.promotion);
            }],
        };
    }];
});



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/mfp/directives/MFPPromotionData.js